/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountPlanConfig } from './accountPlanConfig';


export interface AccountPlanOfferApiModel { 
    planDetails: AccountPlanConfig;
    validFrom: string;
    validTo: string;
}

